import { useState, useEffect } from "react";
import DashboardLayout from "../../../Layouts/Layoutcontainers";
import BTBox from "../../../components/BTBox";
import BTButton from "../../../components/BTButton";
import EnhancedTable from "../../../components/BTTable";
import { Card, IconButton, Tooltip, Zoom } from "@mui/material";
import { Edit, Delete, Error } from "@mui/icons-material";
import authService from "../../../services/auth-service";
import Addparty from "./Addparty";
import ConfirmBox from "../../../components/ConfirmBox";
import BTTypography from "../../../components/BTTypography";
import { useLoading, useNotification } from "../../../context";
import { get_parties } from "../../../store/functions";
import { useSelector } from "react-redux";
const Parties = () => {
  const parties = useSelector((state) => state?.lab?.parties);
  const [open, setOpen] = useState(null);
  const [isDelete, setDelete] = useState(null);
  const { showLoading, hideLoading } = useLoading();
  const { addNotification } = useNotification();
  const CardHeader = () => {
    return (
      <Card sx={{ mb: 1 }}>
        <BTBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          pt={2}
          pb={2}
          px={3}
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
          }}
        >
          <BTButton
            variant="gradient"
            size="small"
            color="dark"
            onClick={() => setOpen({ show: true, actionType: 1 })}
            sx={{ width: { xs: "100%", sm: "auto" } }}
          >
            Add party
          </BTButton>
        </BTBox>
      </Card>
    );
  };
  const Actions = ({ row }) => {
    return (
      <BTBox display="flex" flexDirection={"row"} gap={1}>
        <Tooltip title="Edit" TransitionComponent={Zoom}>
          <Edit
            color="warning"
            sx={{ cursor: "pointer", fontSize: "18px" }}
            onClick={async () => {
              showLoading();
              await new Promise((resolve) => setTimeout(resolve, 1000));
              hideLoading();
              setOpen({
                actionType: 2,
                show: true,
                value: row,
              });
            }}
          />
        </Tooltip>
        <Tooltip title={"Delete"} TransitionComponent={Zoom}>
          <Delete
            color="error"
            sx={{ cursor: "pointer", fontSize: "18px" }}
            onClick={() => {
              setDelete(row);
            }}
          />
        </Tooltip>
      </BTBox>
    );
  };
  const ExpandedComponent = ({ row }) => {
    const Content = row?.p_allias?.map((item, index) => (
      <BTBox
        display="flex"
        gap={1}
        flexDirection="row"
        alignItems="center"
        key={index}
      >
        <BTBox>
          <BTTypography variant="body2" fontSize={"14px"} fontWeight={"bold"}>
            {index + 1}
          </BTTypography>
        </BTBox>
        <BTBox display="flex" gap={1} alignItems="center">
          {/* <Business fontSize="18px" /> */}
          <BTTypography variant="body2" fontSize={"14px"} fontWeight={"bold"}>
            Company :
          </BTTypography>
          <BTTypography variant="body2" fontSize={"14px"}>
            {item?.p_org_name}
          </BTTypography>
        </BTBox>
        <BTTypography fontWeight={"bold"}> </BTTypography>
        <BTBox display="flex" gap={1} alignItems="center">
          {/* <Email fontSize="18px" /> */}
          <BTTypography variant="body2" fontSize={"14px"} fontWeight={"bold"}>
            Email :
          </BTTypography>
          <BTTypography variant="body2" fontSize={"14px"}>
            {item?.p_org_email}
          </BTTypography>
        </BTBox>
        <BTTypography fontWeight={"bold"}> </BTTypography>
        <BTBox display="flex">
          <BTTypography variant="body2" fontSize={"14px"} fontWeight={"bold"}>
            Gst :
          </BTTypography>
          <BTTypography variant="body2" fontSize={"14px"}>
            {item?.p_org_gst}
          </BTTypography>
        </BTBox>
        <BTTypography fontWeight={"bold"}> </BTTypography>
        <BTBox display="flex" gap={1} alignItems="center">
          {/* <Place fontSize="18px" /> */}
          <BTTypography variant="body2" fontSize={"14px"} fontWeight={"bold"}>
            Address 1 :
          </BTTypography>
          <BTTypography variant="body2" fontSize={"14px"}>
            {item?.p_org_address_line1}
          </BTTypography>
        </BTBox>
        <BTTypography fontWeight={"bold"}> </BTTypography>
        <BTBox display="flex" gap={1} alignItems="center">
          {/* <Place fontSize="18px" /> */}
          <BTTypography variant="body2" fontSize={"14px"} fontWeight={"bold"}>
            Address 2 :
          </BTTypography>
          <BTTypography variant="body2" fontSize={"14px"}>
            {item?.p_org_address_line2}
          </BTTypography>
        </BTBox>
        <BTTypography fontWeight={"bold"}> </BTTypography>
        <BTBox display="flex" gap={1} alignItems="center">
          {/* <LocalPhone fontSize="16px" /> */}
          <BTTypography variant="body2" fontSize={"14px"} fontWeight={"bold"}>
            Mo.no 1 :
          </BTTypography>
          <BTTypography variant="body2" fontSize={"14px"}>
            {item?.p_org_mo_no_1}
          </BTTypography>
        </BTBox>
        <BTTypography fontWeight={"bold"}> </BTTypography>
        <BTBox display="flex" gap={1} alignItems="center">
          {/* <LocalPhone fontSize="16px" /> */}
          <BTTypography variant="body2" fontSize={"14px"} fontWeight={"bold"}>
            Mo.no 2 :
          </BTTypography>
          <BTTypography variant="body2" fontSize={"14px"}>
            {item?.p_org_mo_no_2}
          </BTTypography>
        </BTBox>
      </BTBox>
    ));
    const ContentMessage = (
      <BTBox sx={{ p: 2 }}>
        <BTTypography variant="body2">
          There are no records available
        </BTTypography>
      </BTBox>
    );
    return row?.p_allias?.length !== 0 ? Content : ContentMessage;
  };

  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "0.1rem",
      numeric: false,
      sortable: true,
    },
    {
      id: "p_name",
      name: "Party Name",
      cell: (row) => row?.p_name,
      sortable: true,
      numeric: false,
      width: "100px",
    },
    {
      id: "p_address",
      name: "Address",
      numeric: false,
      selector: (row) => row?.p_address,
      sortable: false,
      width: "100px",
    },
    {
      id: " p_mo_no",
      name: "Mo.No",
      selector: (row) => row?.p_mo_no,
      numeric: false,
      sortable: true,
      width: "100px",
    },
    {
      id: "p_email",
      name: "Email",
      selector: (row) => row?.p_email_1,
      numeric: false,
      sortable: true,
      width: "100px",
    },
    {
      id: "p_code",
      name: "Code",
      selector: (row) => row?.p_code,
      numeric: false,
      sortable: true,
      width: "100px",
    },
    {
      id: "p_ref_name",
      name: "Party Reference",
      selector: (row) => row?.p_ref_name,
      numeric: false,
      sortable: true,
      width: "100px",
    },
    {
      id: "p_ref_mo_no",
      name: "Party Mo.No",
      selector: (row) => row?.p_ref_mo_no,
      numeric: false,
      sortable: true,
      width: "100px",
    },
    {
      id: "p_org_name",
      name: "Company Name",
      selector: (row) => row?.p_org_name,
      numeric: false,
      sortable: true,
      width: "100px",
    },
    {
      id: "p_org_address_line1",
      name: "Company Address Line 1",
      selector: (row) => row?.p_org_address_line1,
      numeric: false,
      sortable: true,
      width: "160px",
    },
    {
      id: "p_org_address_line2",
      name: "Company Address Line 2",
      selector: (row) => row?.p_org_address_line2,
      numeric: false,
      sortable: true,
      width: "160px",
    },
    {
      id: "p_org_state",
      name: "State",
      selector: (row) => row?.p_org_state,
      sortable: true,
    },
    {
      id: "p_org_pincode",
      name: "Pincode",
      selector: (row) => row?.p_org_pincode,
      sortable: true,
      numeric: false,
      width: "150px",
    },
    {
      id: "p_org_gst",
      name: "Company GST",
      selector: (row) => row?.p_org_gst,
      numeric: false,
      sortable: true,
      width: "100px",
    },
    {
      id: "p_description",
      name: "Description",
      selector: (row) => row?.p_description,
      numeric: false,
      sortable: true,
      width: "100px",
    },
    {
      id: "actions",
      name: "Actions",
      selector: (row) => <Actions row={row} />,
      width: "80px",
    },
  ];
  const getParties = async () => {
    showLoading();
    await new Promise((resolve) => setTimeout(resolve, 1000));
    const response = await get_parties();
    if (!response?.status) {
      addNotification({
        message: response?.message?.message || "Something went wrong",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    }
    hideLoading();
  };
  useEffect(() => {
    !parties?.is_fetch && getParties();
  }, []);

  return (
    <DashboardLayout>
      <CardHeader />
      <EnhancedTable
        tableHeader={true}
        rows={parties?.data}
        columns={columns}
        title="Parties"
        defaultSort="carbs"
        pagination={true}
        expandRow={true}
        expandComponent={<ExpandedComponent />}
      />
      {Boolean(open) && <Addparty open={open} setOpen={setOpen} />}
      {Boolean(isDelete) && (
        <ConfirmBox
          row={isDelete}
          setDelete={setDelete}
          name="parties"
          id="p_id"
          service={authService?.delete_party}
        />
      )}
    </DashboardLayout>
  );
};
export default Parties;
